import { observer } from "mobx-react-lite"
import Carousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"
import { ErrorHandledImage } from "../../../atoms/ErrorHandledImage"
import styles from "./styles.module.scss"
import { makeAutoObservable } from "mobx"
import { useMemo } from "react"
import { ImagePreviewModal } from "../../../modals/ImagePreviewModal"
import { ICruiseImage } from "@cruisen/contract"
import classNames from "classnames"

class CruiseDetailsHeroStore {
  currentImageIndex: number
  isImageModalVisible: boolean

  constructor() {
    this.currentImageIndex = 0
    this.isImageModalVisible = false

    makeAutoObservable(this)
  }

  changeCurrentImageIndex(value: number) {
    this.currentImageIndex = value
  }

  changeIsImageModalVisible(value: boolean) {
    this.isImageModalVisible = value
  }
}

export const CruiseDetailsHero = observer(function CruiseDetailsHero({
  images,
  roundedTop = true,
}: {
  images: ICruiseImage[]
  roundedTop?: boolean
}) {
  const store = useMemo(() => new CruiseDetailsHeroStore(), [])

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 0 },
      items: 1,
    },
  }

  const hdCruiseImages = images.map((image, index) => ({
    fileName: `Cruise Image ${index + 1}`,
    fileUrl: image.hdUrl ?? image.url,
  }))

  return (
    <>
      <div className={styles.container}>
        <Carousel
          swipeable={false}
          draggable={false}
          responsive={responsive}
          keyBoardControl={false}
          transitionDuration={500}
          afterChange={(_, { currentSlide }) => store.changeCurrentImageIndex(currentSlide)}
        >
          {images.map((image, index) => {
            return (
              <button
                className={styles.imageZoomModalButton}
                onClick={() => store.changeIsImageModalVisible(true)}
                key={`${image.url}-${index}`}
              >
                <ErrorHandledImage
                  uri={image.url}
                  className={classNames(
                    styles.cruiseImage,
                    roundedTop && styles.cruiseImageRoundedTop,
                  )}
                  errorMessage="Cruise image unavailable"
                />
              </button>
            )
          })}
        </Carousel>
        {images.length > 1 && (
          <div className={styles.imageIndex}>
            <p>
              {store.currentImageIndex + 1}/{images.length}
            </p>
          </div>
        )}
      </div>
      {store.isImageModalVisible ? (
        <ImagePreviewModal
          files={hdCruiseImages}
          initialIndex={store.currentImageIndex}
          onClose={() => store.changeIsImageModalVisible(false)}
        />
      ) : null}
    </>
  )
})
